import React, { Component, lazy } from 'react';
import './TypeClient.sass';
import i18n from '../../../../../i18n';
import DataArray from '../../../../../base/config/DataArray';
import LazyLoad from 'react-lazyload';
const AnimateButton = lazy(() => import('../../../../component/animateButton/AnimateButton'));
const Title = lazy(() => import('../../../../component/title/Title'));
const Message = lazy(() => import('./../../../../component/message/Message'));

class TypeClient extends Component {
    constructor(props) {
        super(props);
        this.state = { active: 0, style: {}, buttonStyle: {} };
    }

    handleActive = (active) => {
        var buttonLeft = -70;
        if (active === 1)
            buttonLeft = -10;

        if (active === 0)
            buttonLeft = 20;

        var left = 33 * active;
        this.setState({ active: active });

        setTimeout(() => this.setState({ style: { left: `-${left}%` }, buttonStyle: { marginLeft: `${buttonLeft}%` }, active: active }), 250);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (JSON.stringify(this.state) !== JSON.stringify(nextState)) {
            return true;
        }
        return false;
    }

    render() {
        var dataArray = DataArray.typeClients;

        var title = i18n.t('Why is |Swonkie| for you?');

        var categories = dataArray[this.state.active].categories;
        var logos = dataArray[this.state.active].logos;

        var startTitle = title.indexOf('|') + 1;
        var endTitle = title.indexOf('|', startTitle);
        var text_to_get = title.substring(startTitle, endTitle);

        title = title.replace(`|${text_to_get}|`, `<span class = "Blue" >${text_to_get}</span>`);

        var image = dataArray[this.state.active].image;

        var someHtml = ` ${title} `;
        return (
            <div className="typeClientArea">
                <div className="typeClientMessageArea">
                    <div className="typeClientTitle" >
                        <Title size="Big" type="Secundary" html={someHtml} text="" />
                    </div>
                    <div className="typeClientMessage">
                        <Message size="Bigger" type="Secundary" text={i18n.t('An innovative and cost-effective marketing platform to boost your presence on social media and to get better results, trusted by thousands of social media managers daily.')} />
                    </div>
                </div>
                <div className="typeClientButtonArea">
                    <div className="typeClientButton">
                        <AnimateButton dataArray={dataArray} onSelectActive={this.handleActive} percentage={0} />
                    </div>
                </div>
                <div className="typeClientContentArea">
                    <div className="typeClientContent">
                        <div className="typeClientContentText">
                            <div className="typeClientContentTitle">
                                <Title size="Big" type="Secundary" text={dataArray[this.state.active].title} />
                            </div>
                            <div className="typeClientContentLine" />
                            <div className="typeClientContentMessage">
                                <Message size="Bigger" type="Secundary" text={dataArray[this.state.active].message} />
                            </div>
                            <div className="typeClientContentCategoryArea">
                                {categories.map((category, key) => {
                                    return (
                                        <div key={key} className="typeClientContentCategory">
                                            <div className="typeClientContentCategoryDot" />
                                            <Message size="Bigger" type="Secundary" text={category.message} />
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className="typeClientImageArea">
                            <LazyLoad offset={200} height={400}>
                                <img src={image} alt="typeClientImage" />
                            </LazyLoad>
                        </div>
                    </div>
                </div>
                <div className="typeClientSmallButtonArea" style={this.state.buttonStyle}>
                    <AnimateButton dataArray={dataArray} onSelectActive={this.handleActive} percentage={30} />
                </div>
                <div className="typeClientSmallContentArea">
                    {dataArray.map((typeClient, key) => {
                        return (
                            <div className="typeClientSmallContent" key={key} style={this.state.style}>
                                <div className="typeClientImageArea">
                                    <LazyLoad offset={200} height={400}>
                                        <img alt="typeClientImage" src={image} />
                                    </LazyLoad>
                                </div>
                                <div className="typeClientContentText">
                                    <div className="typeClientContentTitle">
                                        <Title size="Big" type="Secundary" text={typeClient.title} />
                                    </div>
                                    <div className="typeClientContentLine" />
                                    <div className="typeClientContentMessage">
                                        <Message size="Bigger" type="Secundary" text={typeClient.message} />
                                    </div>
                                    <div className="typeClientContentCategoryArea">
                                        {categories.map((category, key) => {
                                            return (
                                                <div key={key} className="typeClientContentCategory">
                                                    <div className="typeClientContentCategoryDot" />
                                                    <Message size="Bigger" type="Secundary" text={category.message} />
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className="typeClientLogoArea">
                    <LazyLoad offset={200} height={50}>
                        {logos.map((logo, key) => {
                            logo = logo.logo;
                            return <img src={logo} alt={key} key={key} />;
                        })}
                    </LazyLoad>
                </div>
            </div>
        );
    }
}

export default TypeClient;
